import { api } from '@xtnd/web/shared/api';
import type {
  TrustEligibleMattersResponse,
  TrustEligibleParams,
  BulkTrustRequestDto,
  BulkTrustRequestResponse,
  IndividualTrustRequestDto,
  IndividualTrustRequestResponse,
  TrustCalculationDto,
  ClientsResponse,
  ClientFilterParams,
  MatterSearchResponse,
  MatterSearchParams,
} from '../types';

export const trustRequestApi = {
  // Get clients for filtering dropdown
  getClientsForFiltering: async (params?: ClientFilterParams): Promise<ClientsResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.hasJuniperEnabled !== undefined) {
      queryParams.set('hasJuniperEnabled', String(params.hasJuniperEnabled));
    }
    if (params?.hasOpenMatters !== undefined) {
      queryParams.set('hasOpenMatters', String(params.hasOpenMatters));
    }
    if (params?.search) {
      queryParams.set('search', params.search);
    }
    if (params?.limit) {
      queryParams.set('limit', String(params.limit));
    }
    const queryString = queryParams.toString();
    return api.get<ClientsResponse>(`/juniper-query/matters/clients${queryString ? `?${queryString}` : ''}`);
  },

  // Search matters for individual creation
  searchMatters: async (params: MatterSearchParams): Promise<MatterSearchResponse> => {
    const queryParams = new URLSearchParams();
    if (params.search) {
      queryParams.set('search', params.search);
    }
    if (params.clientId) {
      queryParams.set('clientId', params.clientId);
    }
    if (params.status) {
      queryParams.set('status', params.status);
    }
    if (params.hasJuniperEnabled !== undefined) {
      queryParams.set('hasJuniperEnabled', String(params.hasJuniperEnabled));
    }
    if (params.limit) {
      queryParams.set('limit', String(params.limit));
    }
    if (params.offset) {
      queryParams.set('offset', String(params.offset));
    }
    const queryString = queryParams.toString();
    return api.get<MatterSearchResponse>(`/juniper-query/matters/search${queryString ? `?${queryString}` : ''}`);
  },

  // Get matters needing trust requests
  getTrustEligibleMatters: async (params: TrustEligibleParams): Promise<TrustEligibleMattersResponse> => {
    const queryParams = new URLSearchParams();
    if (params.clientIds && params.clientIds.length > 0) {
      params.clientIds.forEach(id => queryParams.append('clientIds', id));
    }
    if (params.threshold !== undefined) {
      queryParams.set('threshold', String(params.threshold));
    }
    if (params.hasJuniperEnabled !== undefined) {
      queryParams.set('hasJuniperEnabled', String(params.hasJuniperEnabled));
    }
    if (params.status) {
      queryParams.set('status', params.status);
    }
    if (params.limit) {
      queryParams.set('limit', String(params.limit));
    }
    if (params.cursor) {
      queryParams.set('cursor', params.cursor);
    }
    if (params.sortBy) {
      queryParams.set('sortBy', params.sortBy);
    }
    if (params.sortOrder) {
      queryParams.set('sortOrder', params.sortOrder);
    }
    const queryString = queryParams.toString();
    return api.get<TrustEligibleMattersResponse>(`/juniper-query/matters/trust-eligible${queryString ? `?${queryString}` : ''}`);
  },

  // Get trust calculation for individual matter
  getTrustCalculation: async (matterId: string): Promise<TrustCalculationDto> => {
    return api.get<TrustCalculationDto>(`/juniper-query/matters/${matterId}/trust-calculation`);
  },

  // Create bulk trust requests
  createBulkTrustRequests: async (data: BulkTrustRequestDto): Promise<BulkTrustRequestResponse> => {
    return api.post<BulkTrustRequestResponse>('/juniper/trust-requests/bulk', data);
  },

  // Create individual trust request (queue to SQS for async processing)
  createIndividualTrustRequest: async (data: IndividualTrustRequestDto): Promise<IndividualTrustRequestResponse> => {
    return api.post<IndividualTrustRequestResponse>('/juniper/trust-requests/individual', data);
  },
};

